import { UploadSurplusItemsStepIndex } from '@/admin/modules/stockReceipt/models';
import { createAppAsyncThunk } from '@/admin/helpers';
import { t } from '@/core/localization';
import { areValuesUnique } from '@/core/utils/arrays';
import { getErrorFromException } from '@/core/utils/errorHandling';
import { isEveryFieldDefined } from '@/core/utils/objects';
import { showApiErrorSnackbar } from '@/shared/helpers/thunk';
import { enqueueSnackbar } from 'notistack';
import { stockReceiptApi } from '../stockReceipt.api';
import { stockReceiptActions } from '../stockReceipt.state';
const findSurplusItemsPrices = createAppAsyncThunk('stockReceipt/findSurplusItemsPrices', async ({ stockId }, { getState, dispatch, rejectWithValue }) => {
    const { surplusItemsPreview, surplusItemsSettings } = getState().stockReceipt.uploadSurplusItemsDialog;
    if (!surplusItemsPreview || !isEveryFieldDefined(surplusItemsSettings))
        return;
    const { fileId } = surplusItemsPreview;
    const { articleColumn, brandColumn, quantityColumn, startRow } = surplusItemsSettings;
    if (!areValuesUnique(articleColumn, brandColumn, quantityColumn)) {
        enqueueSnackbar({
            variant: 'info',
            // header: t('upload.surplus.items.columns.must.differ.error'),
            body: t('upload.surplus.items.columns.must.differ.error'),
            autoHideDuration: 10000,
        });
        return rejectWithValue('not unique');
    }
    const requestPayload = {
        fileId,
        stockId,
        articleColumn,
        brandColumn,
        quantityColumn,
        startRow,
    };
    dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(true));
    try {
        const surplusItemsPrices = await dispatch(stockReceiptApi.endpoints.findSurplusItemsPrices.initiate(requestPayload)).unwrap();
        dispatch(stockReceiptActions.setSurplusItemsSearchResult({ surplusItemsPrices }));
        dispatch(stockReceiptActions.setSurplusItemsUploadStep(UploadSurplusItemsStepIndex.PriceSearch));
    }
    catch (error) {
        const errorMessage = getErrorFromException(error);
        dispatch(showApiErrorSnackbar({ header: t('upload.surplus.items.prices.search.failed'), error }));
        return rejectWithValue(errorMessage);
    }
    finally {
        dispatch(stockReceiptActions.setIsSurplusItemsRequestFetching(false));
    }
});
export { findSurplusItemsPrices };
